import ViewRenderer from './ViewRenderer';

export default ViewRenderer;
